module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/share","commonjs2":"rxjs/add/operator/share","amd":"rxjs/add/operator/share"}
// module id = 21
// module chunks = 0 1